/* eslint-disable */
import dayjs from "dayjs";
import React, { useState, useEffect, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Box, Grid, Typography } from "@material-ui/core";

import {
  formActions,
  profileActions,
  reportsActions,
  researchActions,
  rewardActions,
  scoreInformationActions,
  solutionActions,
} from "../../../../actions";
import { photoRender } from "../../../../utils/photoRender";
import {
  APP_SCENE,
  ACHIEVEMENT_TYPE,
  CATEGORY,
  KEYS,
  SECONDARY_COLOR,
} from "../../../../constants";

import styles from "./HoSoDetail.module.css";
import KPTable from "../../../../components/KPTComponents/KPTable";
import PreviewModal from "../../../../components/CustomComponents/PreviewModal";
import ThanhTichInsert from "../../../KVC/ThanhTichInsert/ThanhTichInsert";

import HosoAbout from "../components/about";
import HosoProfile from "../components/profile";

import { capitalizeFirstLetter } from "../../../../utils";
import { hoSoColumnMap } from "../../../../utils/qcv/hoSo.column_table";
import { columnRender } from "../../../../utils";
import MultiPreviewModal from "../../../../components/CustomComponents/MultiPreviewModal/MultiPreviewModal";
import DuyetThanhTichModalV2 from "../../../../components/CustomComponents/DuyetThanhTichModalV2/DuyetThanhTichModalV2";

export default function HoSoDetail(props) {
  const dispatch = useDispatch();

  const [dialog, setDialog] = useState(null);
  const [previewFile, setPreviewFile] = useState(null);
  const [duyetThanhTich, setDuyetThanhTich] = useState(null);

  const user = useSelector((state) => state.userReducer.user);
  const profile = useSelector((state) => state.profileReducer.profile);
  const focusForm = useSelector((state) => state.formReducer.focusForm);
  const openSeasonId = useSelector((state) => state.seasonReducer.openSeasonId);
  const applicationList = useSelector(
    (state) => state.formReducer.applicationList
  );
  const scoreInformationList = useSelector(
    (state) => state.scoreInformationReducer.scoreInformationList
  );

  const urlId = useMemo(() => {
    const arrayPath = window.location.href.split("/");
    return parseInt(arrayPath.slice(arrayPath.length - 1));
  }, []);

  useEffect(() => {
    if (applicationList) {
      const applicationDetail = applicationList.find((e) => e.id === urlId);
      dispatch(formActions.setFocusForm(applicationDetail));
    }
  }, [applicationList]);

  useEffect(() => {
    if (applicationList.length === 0) dispatch(profileActions.getProfileList());
  }, []);

  const applicationDetail = useMemo(() => {
    const detail = { ...focusForm };
    if (focusForm) {
      Object.keys(ACHIEVEMENT_TYPE).forEach((key) => {
        const _key = "form" + capitalizeFirstLetter(ACHIEVEMENT_TYPE[key]);
        detail[ACHIEVEMENT_TYPE[key]] = detail[_key].map((e) => ({
          ...e[ACHIEVEMENT_TYPE[key]],
          note: e.note,
          score: e.score,
          accepted: e.accepted,

          [`${_key}Id`]: e.id,
          thanhTichAccepted: e.accepted,
        }));
      });

      detail[ACHIEVEMENT_TYPE.SOLUTION + CATEGORY.GTNS] = detail[
        ACHIEVEMENT_TYPE.SOLUTION
      ].filter((e) =>
        ["ptns-sc", "ptns-scqg", "ptns-gp"].find((type) => type === e.type)
      );
      detail[ACHIEVEMENT_TYPE.SOLUTION] = detail[
        ACHIEVEMENT_TYPE.SOLUTION
      ].filter((e) => ["sc", "scqg", "gp"].find((type) => type === e.type));

      detail[ACHIEVEMENT_TYPE.REWARD] = detail[ACHIEVEMENT_TYPE.REWARD].map(
        (e) => ({ ...e, issueAt: dayjs(e?.issueAt).format("DD/MM/YYYY") })
      );
      (detail[ACHIEVEMENT_TYPE.REWARD + KEYS.HTQT] = detail[
        ACHIEVEMENT_TYPE.REWARD
      ].filter((e) => ["g1", "g2", "g3-1"].find((type) => type === e.type))),
        (detail[ACHIEVEMENT_TYPE.REWARD + KEYS.HTQG] = detail[
          ACHIEVEMENT_TYPE.REWARD
        ].filter((e) => ["g3-2", "g4", "g5"].find((type) => type === e.type))),
        (detail[ACHIEVEMENT_TYPE.REWARD + KEYS.HTCS] = detail[
          ACHIEVEMENT_TYPE.REWARD
        ].filter((e) =>
          ["nstb-g1", "nstb-g2", "nstb-g3"].find((type) => type === e.type)
        )),
        (detail[ACHIEVEMENT_TYPE.REWARD + KEYS.NCKHCB] = detail[
          ACHIEVEMENT_TYPE.REWARD
        ].filter((e) =>
          ["nstb-n1", "nstb-n2", "nstb-n3", "nstb-n4"].find(
            (type) => type === e.type
          )
        )),
        (detail[ACHIEVEMENT_TYPE.REWARD + KEYS.NCKHCT] = detail[
          ACHIEVEMENT_TYPE.REWARD
        ].filter((e) =>
          ["nstb-n5", "nstb-n6", "nstb-n7"].find((type) => type === e.type)
        )),
        // NSKH 2026 (B.6): đề tài/dự án NCKH nghiệm thu xếp loại đạt
        (detail[ACHIEVEMENT_TYPE.REWARD + KEYS.NCKHDACB] = detail[
          ACHIEVEMENT_TYPE.REWARD
        ].filter((e) => e.type === "nstb-da-cb")),
        (detail[ACHIEVEMENT_TYPE.REWARD + KEYS.NCKHDACT] = detail[
          ACHIEVEMENT_TYPE.REWARD
        ].filter((e) => e.type === "nstb-da-ct")),
        // NSKH 2026: gộp 6.1 + 6.2 thành 1 mục chung
        (detail[ACHIEVEMENT_TYPE.REWARD + KEYS.NCKHDA] = detail[
          ACHIEVEMENT_TYPE.REWARD
        ].filter((e) => ["nstb-da-cb", "nstb-da-ct"].includes(e.type))),
        (detail[ACHIEVEMENT_TYPE.SCIENTIFIC_RESEARCH + KEYS.DOMESTIC] = detail[
          ACHIEVEMENT_TYPE.SCIENTIFIC_RESEARCH
        ].filter((e) => e.filterType === KEYS.DOMESTIC));
      detail[ACHIEVEMENT_TYPE.SCIENTIFIC_RESEARCH + KEYS.INTERNATIONAL] =
        detail[ACHIEVEMENT_TYPE.SCIENTIFIC_RESEARCH].filter(
          (e) => e.filterType === KEYS.INTERNATIONAL
        );

      detail.reward = JSON.parse(focusForm.reward || "[]");
      detail.socialActivity = JSON.parse(detail.socialActivity || "[]");
      detail.majorAchievement = JSON.parse(detail.majorAchievement || "[]");

      const fileList = JSON.parse(detail.previewFile || "[]");
      detail.uploadGpa = fileList?.find((file) => file?.includes("gpa"));
      detail.uploadNominator = fileList?.find((file) =>
        file?.includes("nominator")
      );
      detail.uploadCurriculum = fileList?.find((file) =>
        file?.includes("curriculum")
      );
      detail.uploadSocialActivity = fileList?.filter((file) =>
        file?.includes("fiveSocialActivity")
      );
      // NSKH 2026: file Kê khai thành tích có xác nhận đóng dấu nhà trường
      detail.uploadConfirmation = fileList?.find((file) =>
        file?.includes("confirmation")
      );
      // F. Cam kết: file Bản cam kết của ứng viên
      detail.uploadCamKet = fileList?.find((file) => file?.includes("camKet"));
    }
    return detail;
  }, [focusForm]);

  // `role?.includes` - role có thể còn undefined ở lần render đầu; bản cũ gọi
  // role.includes(...) nên crash trắng trang.
  // Hội đồng bình chọn rơi vào nhánh cuối -> chỉ có "link" (xem minh chứng),
  // KHÔNG có "score" nên không thể chấm điểm dù bảng có hiện cột Điểm.
  const actions = useMemo(() => {
    const role = user?.role;
    if (
      props.isSuperAdmin ||
      !!role?.includes("gtns_admin") ||
      !!role?.includes("ptns_admin")
    )
      return ["link", "edit", "score"];
    else if (applicationDetail.profile?.id === profile?.id)
      return ["link", "detail"];
    else return ["link"];
  }, [user, props.isSuperAdmin, applicationDetail, profile]);

  // Hiện cột Tình trạng/Điểm/Ghi chú. Rộng hơn isSuperAdmin: hội đồng bình chọn
  // xem được điểm. columnRender chỉ thêm các cột đó khi tham số thứ 4 truthy;
  // nút chấm điểm lại phụ thuộc `actions` nên hội đồng vẫn không sửa được.
  const showScoreColumns = props.showScoreColumns ?? props.isSuperAdmin;

  const achievementFields = [
    {
      index: "1",
      actions,
      type: ACHIEVEMENT_TYPE.SOLUTION,
      title:
        "Có bằng độc quyền sáng chế, giải pháp hữu ích thuộc các nhóm ngành xét chọn",
      data: applicationDetail[ACHIEVEMENT_TYPE.SOLUTION]?.map((e) => ({
        ...e,
        issueAt: dayjs(e?.issueAt).format("DD/MM/YYYY"),
      })),
    },
    {
      index: "2",
      actions,
      type: ACHIEVEMENT_TYPE.SOLUTION + CATEGORY.GTNS,
      title:
        "Có sáng chế/ giải pháp hữu ích đã được chấp nhận đơn hợp lệ thuộc các nhóm ngành xét chọn",
      data: applicationDetail[ACHIEVEMENT_TYPE.SOLUTION + CATEGORY.GTNS]?.map(
        (e) => ({ ...e, issueAt: dayjs(e?.issueAt).format("DD/MM/YYYY") })
      ),
    },
    {
      index: "3",
      title:
        "Bài báo khoa học đăng trên tạp chí quốc tế/quốc gia thuộc các nhóm ngành xét giải",
      note: "Ứng viên chỉ khai các tạp chí thuộc danh mục của Hội đồng chức danh GSNN",
      children: [
        {
          index: "3.1",
          actions,
          type: ACHIEVEMENT_TYPE.SCIENTIFIC_RESEARCH + KEYS.INTERNATIONAL,
          title: "Bài báo khoa học trên tạp chí uy tín quốc tế ",
          data: applicationDetail[
            ACHIEVEMENT_TYPE.SCIENTIFIC_RESEARCH + KEYS.INTERNATIONAL
          ],
        },
        {
          index: "3.2",
          actions,
          type: ACHIEVEMENT_TYPE.SCIENTIFIC_RESEARCH + KEYS.DOMESTIC,
          title: "Bài báo khoa học đăng trên tạp chí trong nước",
          data: applicationDetail[
            ACHIEVEMENT_TYPE.SCIENTIFIC_RESEARCH + KEYS.DOMESTIC
          ],
          defaultData: { type: "q6" },
        },
      ],
    },
    {
      index: "4",
      actions,
      title:
        "Bài báo khoa học đăng toàn văn trên kỷ yếu hoặc poster được báo cáo tại hội nghị/hội thảo quốc tế/quốc gia thuộc các nhóm ngành xét giải",
      note: "Không xét với các bài đăng tóm tắt và poster trưng bày",
      type: ACHIEVEMENT_TYPE.SCIENTIFIC_REPORT,
      data: applicationDetail[ACHIEVEMENT_TYPE.SCIENTIFIC_REPORT],
    },
    {
      index: "5",
      title:
        "Tham gia đề tài nghiên cứu khoa học sinh viên thuộc các nhóm ngành xét giải tham gia báo cáo, dự thi",
      note: "Minh chứng là Bằng khen/Giấy khen đề tài",
      children: [
        {
          index: "5.1",
          actions,
          type: ACHIEVEMENT_TYPE.REWARD + KEYS.NCKHCB,
          title:
            "Đề tài nghiên cứu khoa học cấp Bộ và tương đương đã nghiệm thu",
          data: applicationDetail[ACHIEVEMENT_TYPE.REWARD + KEYS.NCKHCB],
        },
        {
          index: "5.2",
          actions,
          type: ACHIEVEMENT_TYPE.REWARD + KEYS.NCKHCT,
          title:
            "Đề tài nghiên cứu khoa học cấp Trường và tương đương đã nghiệm thu",
          data: applicationDetail[ACHIEVEMENT_TYPE.REWARD + KEYS.NCKHCT],
        },
      ],
    },
    {
      // NSKH 2026 (B.6) — gộp 6.1 + 6.2 thành 1 mục chung
      index: "6",
      actions,
      type: ACHIEVEMENT_TYPE.REWARD + KEYS.NCKHDA,
      title:
        "Tham gia đề tài, dự án nghiên cứu khoa học được Hội đồng khoa học có thẩm quyền nghiệm thu, xếp loại đạt yêu cầu trở lên",
      note: "Minh chứng là Biên bản nghiệm thu đề tài, Quyết định xếp loại",
      data: applicationDetail[ACHIEVEMENT_TYPE.REWARD + KEYS.NCKHDA],
    },
    {
      index: "7",
      title:
        "Đạt Huy chương/Giải thưởng các cuộc thi học thuật thuộc các nhóm ngành xét giải",
      children: [
        {
          index: "7.1",
          actions,
          type: ACHIEVEMENT_TYPE.REWARD + KEYS.HTQT,
          title: "Huy chương/Giải thưởng cấp quốc tế",
          data: applicationDetail[ACHIEVEMENT_TYPE.REWARD + KEYS.HTQT],
        },
        {
          index: "7.2",
          actions,
          type: ACHIEVEMENT_TYPE.REWARD + KEYS.HTQG,
          title: "Huy chương/Giải thưởng cấp quốc gia",
          data: applicationDetail[ACHIEVEMENT_TYPE.REWARD + KEYS.HTQG],
        },
        {
          index: "7.3",
          actions,
          type: ACHIEVEMENT_TYPE.REWARD + KEYS.HTCS,
          title: "Huy chương/Giải thưởng cấp Bộ, ban, ngành, tỉnh",
          data: applicationDetail[ACHIEVEMENT_TYPE.REWARD + KEYS.HTCS],
        },
      ],
    },
  ];

  useEffect(() => {
    if (openSeasonId)
      dispatch(
        scoreInformationActions.getScoreInformationBySeasonId(openSeasonId)
      );
  }, [openSeasonId]);

  return (
    <Grid container style={{ padding: 32 }}>
      {/* achievementsOnly: màn "Duyệt thành tích" chỉ hiện bảng thành tích KHCN */}
      {!props.achievementsOnly && (
        <>
          <HosoProfile applicationDetail={applicationDetail} />
          <HosoAbout
            applicationDetail={applicationDetail}
            isSuperAdmin={props.isSuperAdmin}
          />
        </>
      )}

      <Grid item xs={12} style={{ marginTop: props.achievementsOnly ? 0 : 64, marginBottom: 8 }}>
        <Box bgcolor="#c8c7cc" padding={1} fontSize={21}>
          B. THÀNH TÍCH KHOA HỌC CÔNG NGHỆ
        </Box>
      </Grid>
      {achievementFields.map((achivement, id) => {
        return (
          <Grid item xs={12} key={achivement.index}>
            <Box display="flex" margin="8px 0">
              <Box className={styles.circle}>{achivement.index}</Box>
              <Typography className={styles["thanh-tich-title"]} variant="h6">
                {achivement.title}
                {achivement.note && (
                  <i
                    style={{ display: "block", fontSize: 13, fontWeight: 400, color: SECONDARY_COLOR }}
                  >
                    Lưu ý: {achivement.note}
                  </i>
                )}
              </Typography>
            </Box>
            {achivement.children?.map((child) => (
              <>
                <Box display="flex" margin="8px 0">
                  <Typography variant="h6">
                    <b>
                      {child.index}. {child.title}
                    </b>
                  </Typography>
                </Box>
                {child.data && (
                  <KPTable
                    nonBorder={false}
                    rows={child.data}
                    columns={columnRender(
                      child,
                      setDialog,
                      setPreviewFile,
                      showScoreColumns ? setDuyetThanhTich : null
                    )}
                  />
                )}
              </>
            ))}
            {achivement.data && (
              <KPTable
                nonBorder={false}
                rows={achivement.data}
                columns={columnRender(
                  achivement,
                  setDialog,
                  setPreviewFile,
                  showScoreColumns ? setDuyetThanhTich : null
                )}
              />
            )}
          </Grid>
        );
      })}
      {!props.achievementsOnly && (
        <>
          <Grid item xs={5} style={{ marginTop: 64, marginBottom: 8 }}>
            <Box bgcolor="#c8c7cc" padding={1} fontSize={21}>
              C. KHEN THƯỞNG THÀNH TÍCH KHCN
            </Box>
          </Grid>
          <Grid item xs={12}>
            <KPTable
              columns={hoSoColumnMap[APP_SCENE].thanhTichBangKhen(setPreviewFile)}
              rows={applicationDetail.reward || []}
            />
          </Grid>
          <Grid item xs={5} style={{ marginTop: 64, marginBottom: 8 }}>
            <Box bgcolor="#c8c7cc" padding={1} fontSize={21}>
              D. THÀNH TÍCH HOẠT ĐỘNG ĐOÀN, ĐỘI, HỘI
            </Box>
          </Grid>
          <Grid item xs={12}>
            <KPTable
              columns={hoSoColumnMap[APP_SCENE].hoatDongCongDong(setPreviewFile)}
              rows={applicationDetail.socialActivity || []}
            />
          </Grid>
        </>
      )}
      <ThanhTichInsert dialog={dialog} setDialog={setDialog} />
      <PreviewModal
        open={!!previewFile && typeof previewFile === "string"}
        url={previewFile}
        handleClose={() => setPreviewFile(null)}
      />
      <MultiPreviewModal
        open={!!previewFile && typeof previewFile !== "string"}
        url={previewFile}
        handleClose={() => setPreviewFile(null)}
      />
      <DuyetThanhTichModalV2
        info={duyetThanhTich}
        scoreInformationList={scoreInformationList}
        handleClose={() => setDuyetThanhTich(null)}
      />
    </Grid>
  );
}
